import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  query getAuthInfoUserQuery {
    getAuthInfoUserQuery {
      ...UserFragment
    }
  }
  ${userFragment}
`;
